
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import icon from "../../../assets/static/images/secciones/abogados.png";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";

import { AbogadoService } from "../../../_services/abogados.service";
import { useUser } from "../../../hooks/useUser";
import Abogado from "../../../components/Abogado/Abogado";
import ArrowBack from "../../../components/ArrowBack";

const Abogados = ({ dataList, getAbogados }) => {
  const user = useUser();

  const [titulos, setTitulos] = useState([]);
  const [abogado, setAbogado] = useState("");

  useEffect(() => {
    getAbogados();
  }, []);

  useEffect(() => {
    if (dataList?.length) {
      let data = dataList.find(e => e?.nrodni === +user?.dni);

      if (data) {
        setAbogado(data);
      }
    }
  }, [dataList]);

  useEffect(() => {
    const fetchTitulos = async () => {
      try {
        let data = await AbogadoService.getTitulos();
        setTitulos(data);
      }
      catch (err) {
        console.log(err);
      }
    };

    fetchTitulos();
  }, []);

  return (
    <div className="section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="abogados" />
        <span>Mis datos</span>
      </div>
      <ArrowBack />
      <div className="w-full">
        <Abogado data={abogado} getAbogados={getAbogados} titulos={titulos} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dataList: state.dashboard.abogadosList,
    data: state.dashboard.abogado
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAbogados: () => dispatch(getAbogados()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Abogados);